<template>
  <div class="report">
    <div class="report-email">
      <img src="@/assets/images/email.png" alt="">
    </div>
    <div class="report-address">
      举报邮箱：jubao@luotuoguihua.com
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
.report {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:898px;
  height:729px;
  background:rgba(255,255,255,1);
  box-shadow:0px 16px 24px -4px rgba(137,154,230,0.08);
  border:1px solid rgba(236,238,243,0.96);
  .report-email {
    img {
      display: block;
      width: 104px;
      height: 104px;
    }
  }
  .report-address {
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(140,142,162,1);
    line-height:26px;
    letter-spacing:1px;
    margin-top: 11px;
  }
}
</style>
